import { InvestorGoalType, SaveInvestorGoal } from 'types/investment-goals';

export const defaultStarterInvestorGoalType: InvestorGoalType = 'BUILD_WEALTH';

export const defaultStarterInvestorGoalName = '$5k Fundrise account';

export const defaultStarterInvestorGoal: SaveInvestorGoal = {
	goalType: defaultStarterInvestorGoalType,
	goalName: defaultStarterInvestorGoalName,
	targetValue: '5000',
	years: '5',
	goalDripEnabled: true
};
